import { render } from "./ConsumablesModal.vue?vue&type=template&id=43161228&scoped=true"
import script from "./ConsumablesModal.vue?vue&type=script&lang=js"
export * from "./ConsumablesModal.vue?vue&type=script&lang=js"

import "./ConsumablesModal.vue?vue&type=style&index=0&id=43161228&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43161228"]])

export default __exports__